import fetch from '../utils/fetch';
import store from '@/vuex';

/**
 *获取预约记录
 *
 * @export
 * @param {*} bizId
 * @param {*} type
 * @returns
 */
export function appointmentRecordGetByBizId(bizId, type) {
  return fetch.get(`/marketing/api/appointmentRecord/getByBizId?bizId=${bizId}&type=${type}`);
}

/**
 *创建预约
 *
 * @export
 * @param {*} bizId
 * @param {*} type
 * @returns
 */
export function appointmentRecordAppointment(bizId, type) {
  return fetch.post('/marketing/api/appointmentRecord/appointment', { bizId, type });
}

/**
 *返回邀请人
 *
 * @export
 * @returns
 */
export function diagnoseInviteRecordGetMyInviter() {
  return fetch.get('/marketing/api/diagnoseInviteRecord/getMyInviter');
}

/**
 *获取支付完成页连续下单任务的信息
 *
 * @export
 * @returns
 */
export function continuousOrderRecordGetMineAfterOrder() {
  const memberId = store.state.memberCO.id || '';
  return fetch.get(`/marketing/api/continuousOrderRecord/getMineAfterOrder?memberId=${memberId}`);
}

/**
 *获取会员卡礼包
 *
 * @export
 * @param {*} id
 * @returns
 */
export function soyoungVipCardGetInviteVipActivityCard(activityId) {
  return fetch.get('/marketing/api/soyoungVipCard/getInviteVipActivityCard', { activityId });
}

/**
 *获取会员卡信息
 *
 * @export
 * @returns 返现比例，抵扣比例，是否有免费会员卡，会员卡身份：‘NONE’ ‘EEFETIVE’ ‘exprie’
 */
export function vipMemberGetVipMemberCardInfo() {
  let url = '/soyoung/api/vipMember/getVipMemberCardInfo';
  const memberId = store.state.memberCO.id || '';
  if (memberId) {
    url = `${url}?memberId=${memberId}`;
  }
  return fetch.post(url);
}

/**
 *领取免费vip卡
 *
 * @export
 * @returns
 */
export function vipMemberActiveFreeVipCard() {
  return fetch.post('/soyoung/api/vipMember/activeFreeVipCard');
}

/**
 *获取开卡页会员列表
 *
 * @export
 * @returns
 */
export function soyoungVipCardListShopVipCard() {
  return fetch.get('/marketing/api/soyoungVipCard/listShopVipCard');
}

/**
 *获取推荐会员卡信息
 *
 * @export
 * @returns
 */
export function soyoungVipCardGetRecommendedVipCard() {
  return fetch.get('/marketing/api/soyoungVipCard/getRecommendedVipCard');
}

export function bargainInitiateListMine() {
  return fetch.post('/marketing/api/bargainInitiate/listMine');
}

export function getBargainHome(params) {
  return fetch.get('/marketing/api/bargainActivity/home', params);
}

export function wxCouponListByIds(ids) {
  return fetch.post('/marketing/api/wxCoupon/listByIds', ids);
}

export function wxCouponListMyLog(params) {
  return fetch.get('/marketing/api/wxCoupon/listMyLog', params);
}

// 查询用户阿里单品内容
export function getAliInnerItemCoupon(params) {
  return fetch.post(`/marketing/api/coupon/getAliInnerItemCoupon`, params);
}

export function couponListCouponByIds(params) {
  return fetch.post('/marketing/api/coupon/listCouponByIds', params);
}

//
export function activityListPageActivityCommodity(params) {
  // return fetch.post('/marketing/api/activity/listPageActivityCommodity', params);
  // 20230322增加vip橱窗图配置更改
  return fetch.post('/newretail/api/activity/listPageActivityCommodity', params);
}

//
export function activityGetActivityBriefVO(id) {
  return fetch.post(`/marketing/api/activity/getActivityBriefVO?activityId=${id}`);
}

//
export function couponListCouponByCommodity(id) {
  const memberId = store.state.memberCO.id || '';
  return fetch.get(
    `/newretail/api/coupon/listCouponByCommodity?commodityId=${id}&memberId=${memberId}`
  );
}

export function userCouponDraw(couponId) {
  const postData = {
    couponId: couponId,
  };
  return fetch.post('/marketing/api/userCoupon/draw', postData);
}

// 下单时可用/不可用优惠券列表
export function userCouponListCheckOutCoupon(couponIds) {
  return fetch.post('/marketing/api/userCoupon/listCheckOutCoupon', couponIds);
}

export function signPrizeRecordGetSoyoungSignRecord() {
  return fetch.post('/marketing/api/signPrizeRecord/getSoyoungSignRecord', {});
}

export function signPrizeRecordGetAnonSoyoungSignRecord() {
  return fetch.post('/marketing/api/signPrizeRecord/getAnonSoyoungSignRecord', {});
}

// 签到历史
export function signPrizeRecordGetSoyoungSignHistRecord(activityId) {
  const postData = { activityId };
  const memberId = store.state.memberCO.id;
  if (memberId) postData.memberId = memberId;
  return fetch.post('/marketing/api/signPrizeRecord/getSoyoungSignHistRecord', postData);
}

export function signSoyoungDailySign() {
  return fetch.post('/marketing/api/sign/soyoungDailySign');
}

export function signRecordListSignLog(startDate, endDate) {
  const memberId = store.state.memberCO.id || '';
  const postData = {
    data: {
      startDate,
      endDate,
      memberId,
    },
    pageNo: 1,
    pageSize: 31,
  };
  return fetch.post('/marketing/api/signRecord/listSignLog', postData);
}

export function signPrizeRecordPushSoyoungNotify() {
  return fetch.post('/marketing/api/signPrizeRecord/pushSoyoungNotify');
}

// 往期中奖(app)
export function lotteryGamePlayerListLuckyLotteryGamePlayerPage(
  lotteryId,
  lotteryGameId,
  pageNo = 0,
  pageSize = 20,
  orderBy = 'create_date desc'
) {
  const postData = {
    data: { lotteryId, lotteryGameId },
    orderBy,
    pageNo,
    pageSize,
  };
  return fetch.post('/marketing/api/lotteryGamePlayer/listLuckyLotteryGamePlayerPage', postData);
}

// 拼团相关
// 获取0元抽奖活动
export function grouponActivityGetGroupInfo(id) {
  return fetch.get(`/marketing/api/grouponActivity/getGroupInfo?id=${id}`);
}

// 按商品id获取多人拼团活动信息
export function grouponActivityGetGrouponActivityInfo(id) {
  return fetch.get(`/marketing/api/grouponActivity/getGrouponActivityInfo?commodityId=${id}`);
}

// 获取拼团邀请信息
export function grouponActivityInviteInfo(params) {
  return fetch.get('/marketing/api/grouponActivity/inviteInfo', params);
}

// 按活动id获取登录人当前团id
export function grouponActivityGetCurrentGroupId(id) {
  return fetch.get(`/marketing/api/grouponActivity/getCurrentGroupId?id=${id}`);
}

// 限时抢购
export function activityApiListSeckillForFeature(data) {
  return fetch.post('/newretail//api/activity/listSeckillForFeature', data);
}

// 获取用户可使用的团购
export function grouponActivityListGroupPage(id, pageNo = 1, pageSize = 20) {
  const postData = {
    data: id,
    pageNo,
    pageSize,
  };
  return fetch.post('/marketing/api/grouponActivity/listGroupPage', postData);
}

/**
 *助力朋友抽奖(绑定邀请关系)
 *
 * @export
 * @param {*} inviterId
 * @param {*} activityId
 * @returns
 */
export function singleLotteryActivityBindInviteRelation(inviterId, activityId) {
  return fetch.post(
    `/marketing/api/singleLotteryActivity/bindInviteRelation?inviterId=${inviterId}&activityId=${activityId}`
  );
}

/**
 *
 *
 * @export
 * @param {*} inviterId
 * @param {*} activityId
 * @returns
 */
export function singleLotteryActivityReceiverActivityDetail(inviterId, activityId) {
  return fetch.get('/marketing/api/singleLotteryActivity/receiverActivityDetail', {
    inviterId,
    activityId,
  });
}

// 查询最新的支付订单(只有status等于WAIT_PAY呼起支付界面)
export function goodsExchangeRecordGetPayOrder(id) {
  return fetch.get(`/credit-mall-service/api/goodsExchangeRecord/getPayOrder?id=${id}`);
}

// 获取goods对象
export function goodsGetById(id, memberId = '', activityId, activityType) {
  if (activityId && activityType) {
    return fetch.get(
      `/credit-mall-service/api/goods/getById?id=${id}&activityId=${activityId}&activityType=${activityType}&memberId=${memberId}`
    );
  }
  return fetch.get(`/credit-mall-service/api/goods/getById?id=${id}&memberId=${memberId}`);
}

export function goodsExchangeRecordIsExchangeableGoods(creditGoodsId) {
  return fetch.post(
    `/creditmall/api/goodsExchangeRecord/isExchangeableGoods?creditGoodsId=${creditGoodsId}`
  );
}

// 客户端支付回调
export function goodsExchangeRecordPayConfirmByClient(orderId) {
  return fetch.post(
    `/credit-mall-service/api/goodsExchangeRecord/payConfirmByClient?orderId=${orderId}`
  );
}

// 获取兑换详情
export function goodsExchangeRecordGet(id) {
  return fetch.get(`/credit-mall-service/api/goodsExchangeRecord/get?id=${id}`);
}

// 兑换商品--创建订单
export function goodsExchangeRecordExchange(data) {
  // 读取推广员信息
  const { promoter } = store.state;
  if (promoter) {
    data.promoterId = promoter;
  }
  return fetch.post('/credit-mall-service/api/goodsExchangeRecord/exchange', data);
}

// 支付宝积分查询
// export function alipayPointQuery(data) {
//   const memberId = store.state.memberCO.id;
//   if (memberId) {
//     data.memberId = memberId;
//   }
//   return fetch.post('/shopmember/api/alipayCredit/preconsult', data);
// }

// 获取未使用的优惠券
export function userCouponListMyUnusedCoupon(pageNo = 1, pageSize = 20) {
  return fetch.post('/marketing-service/api/userCoupon/listMyUnusedCoupon', {
    pageNo,
    pageSize,
  });
}

// 获取已使用的优惠券
export function userCouponListMyUsedCoupon(pageNo = 1, pageSize = 20) {
  return fetch.post('/marketing-service/api/userCoupon/listMyUsedCoupon', {
    pageNo,
    pageSize,
  });
}

// 获取已过期的优惠券
export function userCouponListMyExpireCoupon(pageNo = 1, pageSize = 20) {
  return fetch.post('/marketing-service/api/userCoupon/listMyExpireCoupon', {
    pageNo,
    pageSize,
  });
}

// 获取砍价商品详情
export function bargainActivityPrizeGetPrizeDetail(prizeId) {
  const memberId = store.state.memberCO.id;
  if (memberId) {
    return fetch.get(
      `/marketing/api/bargainActivityPrize/getPrizeDetail?prizeId=${prizeId}&memberId=${memberId}`
    );
  } else {
    return fetch.get(`/marketing/api/bargainActivityPrize/getPrizeDetail?prizeId=${prizeId}`);
  }
}

export function bargainInitiateCreate(prizeId) {
  const postData = {
    prizeId,
  };
  return fetch.post('/marketing/api/bargainInitiate/create', postData);
}

export function cashBackOrderLogGetByOrderId(id) {
  return fetch.get('/marketing/api/cashBackOrderLog/getByOrderId', { orderId: id });
}

// 去使用大宝剑-获取活动列表弹窗数据
export function bargainInitiateListUseSupercutInitiate() {
  return fetch.post('/marketing/api/bargainInitiate/listUseSupercutInitiate');
}

// 使用大宝剑砍价
export function bargainToolBargainBySupercut(data) {
  return fetch.post('/marketing/api/bargainTool/bargainBySupercut', data);
}

export function bargainToolListMyUsefulTool(pageNo, pageSize = 10) {
  // return fetch.post('/marketing/api/bargainTool/listMyUsefulTool');
  return fetch.post('/marketing/api/bargainTool/listMyUsefulTool', {
    data: {},
    pageNo,
    pageSize,
  });
}

// 帮砍页获取活动信息
export function bargainInitiateGetHelpProcess(initiateId) {
  return fetch.get(`/marketing/api/bargainInitiate/getHelpProcess?initiateId=${initiateId}`);
}

// 砍价活动 历史道具页
export function bargainToolListMyToolHistory(pageNo, pageSize = 20) {
  return fetch.post('/marketing/api/bargainTool/listMyToolHistory', {
    data: {},
    pageNo,
    pageSize,
  });
}

// 获取我的砍价进度
export function bargainInitiateGetMyProcess(id) {
  return fetch.get(`/marketing/api/bargainInitiate/getMyProcess?initiateId=${id}`);
}

// 领取红包
export function bargainPcpRecordDrawRedPacket(id) {
  return fetch.get(`/marketing/api/bargainPcpRecord/drawRedPacket?initiateId=${id}`);
}

// 创建砍价订单
export function bargainOrderCreate(addressId, bargainInitiateId) {
  return fetch.post('/marketing/api/bargainOrder/create', { addressId, bargainInitiateId });
}

export function bargainInitiateGetInitiatorInfo(memberId) {
  return fetch.get(`/marketing/api/bargainInitiate/getInitiatorInfo?memberId=${memberId}`);
}

export function bargainToolTakeSupercut(sourceInitiateId, sourceMemberId) {
  const postData = {
    sourceInitiateId,
    sourceMemberId,
  };
  return fetch.post('/marketing/api/bargainTool/takeSupercut', postData);
}

// 是否有大宝剑任务
export function bargainToolHasShareSupercutTask(initiateId) {
  return fetch.get(`/marketing/api/bargainTool/hasShareSupercutTask?initiateId=${initiateId}`);
}

// 帮砍人帮砍
export function bargainPcpRecordHelpBargain(data) {
  return fetch.post('/marketing/api/bargainPcpRecord/helpBargain', data);
}

// 分享者主动分享
export function bargainPcpRecordShareWechat(data) {
  return fetch.post('/marketing/api/bargainPcpRecord/shareWechat', data);
}

// 是否助力过
export function bargainPcpRecordHasHelped() {
  return fetch.get('/marketing/api/bargainPcpRecord/hasHelped');
}

// 砍价订单支付成功后回调
export function bargainOrderPaid(orderId) {
  return fetch.post(`/marketing/api/bargainOrder/paid?orderId=${orderId}`);
}

// 获取最新的砍价活动
export function bargainActivityGetLatest() {
  return fetch.get('/marketing/api/bargainActivity/getLatest');
}

// 获取最新的砍价活动
export function bargainInitiateGetBargainState(prizeId) {
  // return fetch.get('/marketing/api/bargainInitiate/getBargainState');
  return fetch.get(`/marketing/api/bargainInitiate/getBargainState?prizeId=${prizeId}`);
}

export function featureHome() {
  return fetch.get('/marketing/api/feature/home');
}

// 获取H5首页
export function featureGetDefaultHomePageCategoryHome() {
  return fetch.get('/marketing/api/feature/getDefaultHomePage?category=HOME');
}

export function featureGetDefaultWeappHomePage() {
  // return fetch.get(`/marketing/api/feature/getDefaultWeappHomePage?category=HOME`);
  // 20230322增加vip橱窗图配置更改
  const memberId = store.state.memberCO.id || '';
  return fetch.get(
    `/newretail/api/feature/getDefaultWeappHomePage?category=HOME&memberId=${memberId}`
  );
}

// 领取我的连续下单奖励
export function continuousOrderRecordReceive(activityId) {
  return fetch.post(`/marketing/api/continuousOrderRecord/receive?activityId=${activityId}`);
}

// 查看我的连续下单奖励记录，未登录可不传memberId

export function continuousOrderRecordGetMine(activityId) {
  const memberId = store.state.memberCO.id;
  let url = `/marketing/api/continuousOrderRecord/getMine?activityId=${activityId}`;

  if (memberId) {
    url += '&memberId=' + memberId;
  }

  return fetch.get(url);
}

/**
 * 获取签到中心微页面模板
 */
export function featureGetByCategory(category) {
  return fetch.post(`/marketing-service/api/feature/getByCategoryForApp?category=${category}`);
}

/**
 *
 *获取购物车地区栏广告信息
 * @export
 * @returns
 */
export function shoppingCartAdGetBarAd() {
  return fetch.get('/marketing/api/shoppingCartAd/getBarAd');
}

// 单品抽奖，奖品详情获取
export function singleLotteryActivityGetDetail(activityId) {
  const memberId = store.state.memberCO.id;
  const url = memberId ? `&memberId=${memberId}` : '';
  return fetch.get(`/marketing/api/singleLotteryActivity/getDetail?activityId=${activityId}${url}`);
}

// 单品抽奖，参与活动
export function singleLotteryActivityRedeemLotteryCode(activityId) {
  return fetch.post(
    `/marketing/api/singleLotteryActivity/redeemLotteryCode?activityId=${activityId}`
  );
}

// 单品抽奖，获取分享信息
export function singleLotteryActivityGetShareInfo(activityId) {
  return fetch.get(`/marketing/api/singleLotteryActivity/getShareInfo?activityId=${activityId}`);
}

// 单品抽奖
export function singleLotteryActivityListCurrentActivityInfo(memberId = '') {
  // return fetch.get(API_SINGLE_LOTTERY_LIST_CURRENT);
  return fetch.get(
    `/marketing/api/singleLotteryActivity/listCurrentActivityInfo?memberId=${memberId}`
  );
}

export function singleLotteryActivityListFutureActivityInfo(memberId = '') {
  return fetch.get(
    `/marketing/api/singleLotteryActivity/listFutureActivityInfo?memberId=${memberId}`
  );
}

export function singleLotteryActivityListMyCurrentActivity() {
  return fetch.get('/marketing/api/singleLotteryActivity/listMyCurrentActivity');
}

export function singleLotteryActivityMyHistActivityPage(
  pageNo = 1,
  pageSize = 10,
  orderBy = 'update_date'
) {
  // return fetch.get(`${API_SINGLE_LOTTERY_LIST_MY_HISTORY}?pageNo=${pageNo}&pageSize=${pageSize}&orderBy=${orderBy}`);
  const postData = {
    pageNo,
    pageSize,
    orderBy,
  };
  return fetch.post('/marketing/api/singleLotteryActivity/myHistActivityPage', postData);
}

export function singleLotteryActivitySingleLotteryBaseInfo() {
  return fetch.get('/marketing/api/singleLotteryActivity/singleLotteryBaseInfo');
}

// 单品抽奖，获取中奖名单
export function singleLotteryActivityListLuckyLotteryCode(activityId) {
  return fetch.get(
    `/marketing/api/singleLotteryActivity/listLuckyLotteryCode?activityId=${activityId}`
  );
}

/**
 * 单品抽奖,创建预约
 */
export function singleLotteryActivityAppointment(bizId, type) {
  return fetch.post('/marketing/api/singleLotteryActivity/appointment', { bizId, type });
}

/**
 * V2.16.2
 * @param {*} id
 */
export function presentGetBriefById(id) {
  return fetch.get(`/marketing/api/present/getBriefById?id=${id}`);
}

/**
 * APP-开卡页
 * ids-【券id】
 */
export function soyoungVipCardGetInviteVipCardById(vipCardId) {
  return fetch.get(`/marketing/api/soyoungVipCard/getInviteVipCardById?vipCardId=${vipCardId}`);
}

/**
 * 发起我的关注有礼,返回邀请二维码
 * activityId
 */

export function mpSubscribeActivityInitiateMine(activityId = '') {
  return fetch.post(`/marketing/api/mpSubscribeActivity/initiateMine?id=${activityId}`);
}

/**
 * 领取奖品
 * activityId
 */

export function mpSubscribePcpRecordDraw(prizeRecordId = '') {
  return fetch.post(`/marketing/api/mpSubscribePcpRecord/draw?prizeRecordId=${prizeRecordId}`);
}

// v2.9 关注有礼 20200826
/**
 * 查询活动信息
 * activityId
 */
export function mpSubscribeActivityGetForApp(activityId = '') {
  return fetch.get(`/marketing/api/mpSubscribeActivity/getForApp?id=${activityId}`);
}

/**
 * 我的关注有礼-邀请记录
 * activityId orderBy = 'create_date desc'
 */

export function mpSubscribePcpRecordListMyRecord(
  activityId = '',
  pageNo = 0,
  pageSize = 5,
  orderBy = 'update_date desc'
) {
  const postData = {
    data: {
      activityId,
    },
    pageNo,
    pageSize,
    orderBy,
  };
  return fetch.post('/marketing/api/mpSubscribePcpRecord/listMyRecord', postData);
}

/**
 * 查询我的奖品领取列表
 * activityId
 */

export function mpSubscribeActivityListMyThresholds(activityId = '') {
  return fetch.get(`/marketing/api/mpSubscribeActivity/listMyThresholds?id=${activityId}`);
}

/**
 * V2.19.0
 * API_GET_CREDIT_CHOOSE_ANYONE_ACTIVITY
 */
export function creditChooseAnyoneActivityGetForApp(id, memberId = '') {
  const query = memberId ? `?id=${id}&memberId=${memberId}` : `?id=${id}`;
  return fetch.get(`/creditmall/api/creditChooseAnyoneActivity/getForApp${query}`);
}

/**
 * 获取微信商家券的签名信息等
 * ids-【券id】
 */

export function couponListWxSignParamsByIds(ids) {
  return fetch.post('/marketing/api/coupon/listWxSignParamsByIds', ids);
}

export function couponListWxH5SignParamsById(id, openId) {
  return fetch.post(`/marketing/api/coupon/listWxH5SignParamsById?id=${id}&openId=${openId}`);
}

/**
 * 测肤
 *
 */
// 邀请测肤奖品发放记录
export function diagnoseInviteDrawRecordListPage(data) {
  return fetch.post(`/marketing/api/diagnoseInviteDrawRecord/listPage`, data);
}

// 获取活动邀请记录
export function diagnoseInviteRecordListPage(data) {
  return fetch.post(`/marketing/api/diagnoseInviteRecord/listPage`, data);
}

export function diagnoseInviteActivityHome() {
  return fetch.get('/marketing/api/diagnoseInviteActivity/home');
}

export function diagnoseInviteRecordBindInviteRelation(inviterId) {
  if (inviterId) {
    return fetch.post(
      `/marketing/api/diagnoseInviteRecord/bindInviteRelation?inviterId=${inviterId}`
    );
  }
}

export function diagnoseSkinPlanGetMyPlanByType(
  type,
  recordId = '',
  associateAttr = '',
  oilShine = '',
  sensitivityStatus = ''
) {
  const postData = {
    type,
    recordId,
    associateAttr,
    oilShine,
    sensitivityStatus,
  };
  return fetch.post('/marketing/api/diagnoseSkinPlan/getMyPlanByType', postData);
}

// 获取肤质报告
export function diagnoseSkinRecordGetReportV2(id) {
  return fetch.get(`/marketing/api/diagnoseSkinRecord/getReportV2?id=${id}`);
}

// 获取分享海报及卡片信息
export function diagnoseSkinShareGetByRecord(id) {
  return fetch.get(`/marketing/api/diagnoseSkinShare/getByRecord?recordId=${id}`);
}

// 获取最近的一次的信息
export function diagnoseSkinRecordGetRecentReport() {
  return fetch.get('/marketing/api/diagnoseSkinRecord/getRecentReport');
}

// AI测肤，获取最新的活动信息
export function diagnoseInviteActivityGetCurrentActivity() {
  return fetch.get('/marketing/api/diagnoseInviteActivity/getCurrentActivity');
}

export function diagnoseSkinRecordGetReportDetail(id, type) {
  return fetch.get(`/marketing/api/diagnoseSkinRecord/getReportDetail?id=${id}&type=${type}`);
}

// 我的测肤图像 图像页
export function diagnoseSkinRecordListReportImages() {
  return fetch.post('/marketing/api/diagnoseSkinRecord/listReportImages');
}

// 我的记录页判断是否有测肤图像入口
export function diagnoseSkinRecordLastMonthMineHasDiagnose() {
  return fetch.get('/marketing/api/diagnoseSkinRecord/lastMonthMineHasDiagnose');
}

/**
 * AI测肤 历史记录
 */
export function diagnoseSkinRecordListMyHistPage(data) {
  return fetch.post('/marketing/api/diagnoseSkinRecord/listMyHistPage', data);
}

/**
 * AI测肤 肤质变化
 */
export function diagnoseSkinRecordSkinChange(data) {
  return fetch.post('/marketing/api/diagnoseSkinRecord/skinChange', data);
}

/**
 *获取满意度
 *
 * @export
 * @param {*} params
 * @returns
 */
export function diagnoseSkinFeedbackGet(params) {
  return fetch.post('/marketing/api/diagnoseSkinFeedback/get', params);
}

/**
 *提交满意度
 *
 * @export
 */
export function diagnoseSkinFeedbackSubmit(params) {
  return fetch.post('/marketing/api/diagnoseSkinFeedback/submit', params);
}

/**
 *提交测肤意见
 *
 * @export
 * @param {*} params
 * @returns
 */
export function diagnoseSkinFeedbackSubmitSuggest(params) {
  return fetch.post('/marketing/api/diagnoseSkinFeedback/submitSuggest', params);
}

/**
 *更新测肤状态
 *
 * @export
 * @param {*} params
 * @returns
 */
export function diagnoseSkinRecordUpdateDiagnoseStatus(params) {
  return fetch.post('/marketing/api/diagnoseSkinRecord/updateDiagnoseStatus', params);
}

/**
 * 测肤，批量提交意见
 */
export function diagnoseSkinFeedbackBatchSubmitSuggest(params) {
  return fetch.post('/marketing/api/diagnoseSkinFeedback/batchSubmitSuggest', params);
}

/**
 * v2.22.3 绑定促销员
 */
export function promoteRelationshipBindPromoter(promoterId, pageUrl, type) {
  const postData = {
    promoterId,
  };
  // 判断是否存在绑定关系类型
  if (type) {
    postData.type = type;
  }
  if (pageUrl) {
    postData.bindDetail = pageUrl;
  }
  return fetch.post('/order/api/promoteRelationship/bindPromoter', postData);
}

/**
 * v2.22.3 获取我的促销员信息
 */
export function promoteRelationshipGetMyPromoter() {
  return fetch.get('/order/api/promoteRelationship/getMyPromoter');
}

// 登录后，本地没id时候调用，后台开发刚子
export function promoteNewUserBindPromoter() {
  return fetch.post('/order/api/promoteRelationship/newUserBindPromoter');
}

export function searchSearchV2(data) {
  // return fetch.post('/marketing-service/api/search/searchV2', data);
  // 20230322增加vip橱窗图配置更改
  return fetch.post('//newretail/api/searchV2/soyoungSearch', data);
}

export function marketingListCommodityByCategoryAndOrderBy(
  categoryId,
  pageNo = 0,
  pageSize = 30,
  orderBy = ''
) {
  const postData = {
    data: { categoryId },
    orderBy,
    pageNo,
    pageSize,
  };
  if (orderBy !== '') {
    postData.orderBy = orderBy;
  }
  // return fetch.post('/marketing/api/marketing/listCommodityByCategoryAndOrderBy', postData);
  // 20230322增加vip橱窗图配置更改
  const memberId = store.state.memberCO.id;
  memberId && (postData.memberId = memberId);
  return fetch.post('/newretail/api/marketing/listCommodityByCategoryAndOrderBy', postData);
}

export function activityListActivityRuleForCommodity(id, memberId) {
  if (memberId) {
    return fetch.post(
      `/marketing/api/activity/listActivityRuleForCommodity?commodityId=${id}&memberId=${memberId}`
    );
  }
  return fetch.post(`/marketing/api/activity/listActivityRuleForCommodity?commodityId=${id}`);
}

export function searchListHotSearch(data = '', pageNo = 1) {
  const params = {
    data,
    pageNo,
    pageSize: 20,
  };
  return fetch.get('/marketing/api/search/listHotSearch', params);
}

// 获取新趋热点
export function searchHotBillboard(data = '', pageNo = 1) {
  const params = {
    data,
    pageNo,
    pageSize: 10,
  };
  return fetch.post('/marketing/api/searchHotBillboard/listPageForApp', params);
}

// 获取置顶文案
export function featureSearchWord() {
  return fetch.get('/marketing/api/searchConfig/getForApp');
}

export function commodityEsGetSearchFilterCondition(data) {
  return fetch.post('/commodity/api/commodityEs/getSearchFilterCondition', data);
}

/**
 * 获取免登陆领奖活动对象
 */
export function anonRewardActivityGetApp(id) {
  return fetch.get(`/marketing/api/anonRewardActivity/getApp?id=${id}`);
}

/**
 *获取购物车付邮礼品推荐弹窗
 *
 * @export
 * @returns
 */
export function shoppingCartAdGetPopWindowAdForApp(type, presentId) {
  let url = `/marketing/api/shoppingCartAd/getPopWindowAdForApp?typeEnum=${type}`;
  if (presentId) {
    url += `&presentId=${presentId}`;
  }
  return fetch.get(url);
}
/**
 * 获取购物车礼包级第一层搭配弹框(购物车区域)
 * @param {} presentId
 * @returns
 */
export function shoppingCartAdGetPresentMatchInCartForApp(presentId = '') {
  const params = {
    presentId,
  };
  return fetch.post('/marketing/api/shoppingCartAd/getPresentMatchInCartForApp', params);
}

/**
 * 获取第二层搭配弹框商品(购物车区域)
 * @param {} params
 * @returns
 */
export function shoppingCartAdListAdPopupWindowForApp(params) {
  return fetch.post('/marketing/api/shoppingCartAd/listAdPopupWindowForApp', params);
}

/**
 * 获取第三层搭配弹框商品(结算页区域)
 * @param {} params
 * @returns
 */
export function shoppingCartAdListAdInCalculateForApp(params) {
  return fetch.post('/marketing/api/shoppingCartAd/listAdInCalculateForApp', params);
}

/**
 * 获取第四层搭配弹框商品(礼包搭配)
 * @param {} params
 * @returns
 */
export function shoppingCartAdListAdInActivityForApp(params) {
  return fetch.post('/marketing/api/shoppingCartAd/listAdInActivityForApp ', params);
}
/**
 *获取购物车弹窗广告（支持批量返回）v3.4.0(搭配弹框升级)
 *
 * @export
 * @returns
 */
export function shoppingCartAdListPopWindowAdForApp(type, presentId) {
  return fetch.get(
    `/marketing/api/shoppingCartAd/listPopWindowAdForApp?typeEnum=${type}&presentId=${presentId}`
  );
}

export function marketingConfigShopGetFlagByConfigType(configType) {
  return fetch.get(
    `/marketing/api/marketingConfigShop/getFlagByConfigType?configType=${configType}`
  );
}

// 领取微信优惠券
export function wxCouponReceive(id) {
  return fetch.post(`/marketing/api/wxCoupon/receive?id=${id}`);
}

// 批量领取优惠券
export function userCouponBatchDraw(postData) {
  return fetch.post('/marketing/api/userCoupon/batchDraw', postData);
}

// 批量领取礼包
export function presentBatchDrawPresent(postData) {
  return fetch.post('/marketing/api/present/batchDrawPresent', postData);
}

// 领取礼包
export function presentDrawPresent(postData) {
  return fetch.post('/marketing/api/present/drawPresent', postData);
}

// 手机号兑换
export function redeemMobileExecRedeem(data) {
  let url = '';

  url = '/marketing/api/redeemMobile/execRedeem'; // 手机号兑换




  return fetch.post(url, data);
}

// 手机号兑换页面获取banner的url
export function redeemMobileGetMaterialBannerUrl(activityId) {
  return fetch.get(`/marketing/api/redeemMobile/getMaterialBannerUrl?activityId=${activityId}`);
}

// 手机号升级版兑换页面获取banner的url
export function redeemMobileUpgradeGetMaterialBannerUrl(type) {
  return fetch.get(`/marketing/api/redeemCommon/listRedeemBaseInfoForApp?activityType=${type}`);
}

export function featureGetDetail(id) {
  // return fetch.get(`/marketing/api/feature/getDetail?id=${id}`);
  // 20230322增加vip橱窗图配置更改
  const memberId = store.state.memberCO.id || '';
  return fetch.get(`/newretail/api/feature/getDetail?featureId=${id}&memberId=${memberId}`);
}

export function featureGetDetailV2(id) {
  const memberId = store.state.memberCO.id || '';
  return fetch.get(`/marketing/api/feature/getDetailV2?id=${id}&memberId=${memberId}`);
}

//  积分兑换
export function smisOrderActivitySendCredit() {
  return fetch.post('/marketing/api/smisOrderActivity/sendCredit');
}

//  兑换码兑换
export function redeemCodeExecRedeem(data) {
  return fetch.post('/marketing/api/redeemCode/execRedeem', data);
}
/**
 * 校验是否已经加入企微
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E4%B8%AD%E5%BF%83-%E8%90%A5%E9%94%80%E6%B4%BB%E5%8A%A8/RedeemCode/checkIfJoinQWUsingPOST
 */
export function checkIfJoinQW(data) {
  return fetch.post('/marketing/api/redeemCode/checkIfJoinQW', data);
}

// 手机号领奖判断是否已领取
export function redeemMobileGetIsRedeemed(activityId) {
  return fetch.get(`/marketing/api/redeemMobile/getIsRedeemed?activityId=${activityId}`);
}

export function wechatLotteryRecordListBriefPage(lotteryActivityId, pageNo = 1) {
  const memberId = store.state.memberCO.id || '';
  return fetch.post('/marketing/api/wechatLotteryRecord/listBriefPage', {
    data: { lotteryActivityId, memberId },
    pageSize: 30,
    pageNo,
  });
}

export function wechatLotteryRecordDrawLottery(params) {
  const { openId } = store.state;
  return fetch.post('/marketing/api/wechatLotteryRecord/drawLottery', {
    ...params,
    openId,
  });
}

export function wechatLotteryShareCreateShareUser(lotteryActivityId, fromMemberId) {
  const shareMemberId = store.state.memberCO.id;
  return fetch.post('/marketing/api/wechatLotteryShare/createShareUser', {
    lotteryActivityId,
    memberId: fromMemberId || '',
    shareMemberId,
  });
}

export function wechatLotteryActivityLotteryUnLogin(activityId) {
  return fetch.post(`/marketing/api/wechatLotteryActivity/lotteryUnLogin?activityId=${activityId}`);
}

export function wechatLotteryActivityLotteryLogin(activityId) {
  return fetch.post(`/marketing/api/wechatLotteryActivity/lotteryLogin?activityId=${activityId}`);
}

// 获取运费设置对象
export function deliveryOptionsGetByCache() {
  return fetch.get('/marketing/api/deliveryOptions/getByCache');
}

/**
 *获取特殊礼包列表
 *
 * @export
 * @returns
 */
export function shoppingCartAdListAssignPresentId(type, presentId) {
  return fetch.get(`/marketing/api/shoppingCartAd/listAssignPresentId`);
}

export function upgradePresentGroupGetUpgradePresent() {
  return fetch.get('/marketing/api/upgradePresentGroup/getUpgradePresent?typeEnum=PRESENT_UPGRADE');
}

export function memberPresentUpgradeDetailPopStart(id) {
  return fetch.post('/marketing/api/memberPresentUpgradeDetail/popStart', { id });
}

export function upgradePresentGroupListRecommendCommodity(groupId) {
  return fetch.post(`/marketing/api/upgradePresentGroup/listRecommendCommodity?groupId=${groupId}`);
}

// 隐私协议查询是否更新
export function isReadAgreementNotice() {
  const memberId = store.state.memberCO.id || '';
  return fetch.post(`/marketing/api/agreementNotice/isRead?memberId=${memberId}`);
}

// 隐私协议用户已同意
export function agreeAgreementNotice() {
  const memberId = store.state.memberCO.id || '';
  return fetch.post(`/marketing/api/agreementNotice/agree?memberId=${memberId}`);
}
// 获取购物车换购门槛列表
export function shoppingCartAdGetRedemptionThresholdForApp() {
  return fetch.post(`/marketing/api/shoppingCartAd/getRedemptionThresholdForAppV2`);
}
// 购物车v2.0 换购页加载
export function getRedemptionWholeConfigForApp(data) {
  return fetch.post(
    `/marketing/api/shoppingCartAd/getRedemptionWholeConfigForApp?itemType=${data}`
  );
}
/**
 * V3.8 购物车
 * @param {*} id
 */
export function listRedemptionByOrderId(orderId) {
  return fetch.get(`/order/api/order/listRedemptionByOrderId?orderId=${orderId}`);
}

/**
 *获取升级版本手机号领奖及兑换码领奖详情
 * @param {*} id 活动id
 * @returns
 */
export function getActivityInfoForApp(id) {
  // return fetch.get(`/marketing/api/redeemCommon/getActivityInfoForApp?activityId=${id}`);
  // 接入支付宝积分权益组件时更改接口 230605
  return fetch.get(`/newretail/api/redeemCommon/getActivityInfoForApp?activityId=${id}`);
}

/**
 *获取升级礼包第一层搭配
 * @param {*} id 礼包id
 * @returns
 */
export function listPresentMatchForApp(presentId = '', pageNo, pageSize) {
  const params = {
    data: {
      presentId,
    },
    pageSize,
    pageNo,
  };
  return fetch.post('/marketing/api/redeemCommon/listPresentMatchForApp', params);
}

// 手机号兑换升级版
export function redeemPpgradeMobileExecRedeem(data) {
  return fetch.post('/marketing/api/redeemMobile/fastExecRedeemV2', data);
}

//  兑换码兑换
export function redeemCodeExecRedeemV2(data) {
  return fetch.post('/marketing/api/redeemCode/execRedeemV2', data);
}

//  分享官身份认证
export function getShareOfficerAuth() {
  return fetch.post('/marketing/api/shareOfficer/auth');
}

//  分享官基础配置
export function shareOfficerConfig(data) {
  return fetch.get('/marketing/api/shareOfficerConfig/getForApp', data);
}

//  申请成为分享官
export function shareOfficerApplay(data) {
  return fetch.post('/marketing/api/shareOfficer/apply', data);
}

//  分享官实名认证
export function shareOfficerRealNameAuth(data) {
  return fetch.post('/marketing/api/shareOfficer/realNameAuth', data);
}

//  分享官绑定
export function shareOfficerBindUser(data) {
  return fetch.post('/marketing/api/shareOfficer/bind', data);
}

//  选择主题
export function shareOfficerChooseTheme(data) {
  return fetch.post('/marketing/api/shareOfficer/chooseTheme', data);
}

// 获取分享官批次订单
export function getShareOfficerOrder(data) {
  return fetch.post('/marketing/api/shareOfficerOrder/listBatchOrders', data);
}

// 分享官结算明细
export function getShareOfficerCheckoutDetails(data) {
  return fetch.post('/marketing/api/shareOfficerOrder/listCheckoutDetails', data);
}

// 分享官结算明细
export function getShareOfficerOrderStatistics(data) {
  return fetch.post('/marketing/api/shareOfficerOrder/getCommissionStatistics', data);
}

// 获取面膜卡详情
export function getMaskCardInfo(id, isLogin) {
  let url = `/marketing/api/maskCardActivity/get?id=${id}`;
  if (isLogin) {
    url = `/marketing/api/maskCardActivity/getDetail?id=${id}`;
  }
  return fetch.get(url);
}

// 面膜卡支付成功后，确认订单
export function maskConfirmOrder(orderId) {
  return fetch.post(`/marketing/api/maskCardActivity/payConfirmByClient?orderId=${orderId}`);
}

// 面膜卡下单
export function createMaskCardOrder(data) {
  return fetch.post('/marketing/api/maskCardActivity/createOrder', data);
}

// 获取商品兑换券列表
export function getGoodsCouponList(pageNo = 1, pageSize = 20, status = 'UNUSED') {
  return fetch.post(`/marketing/api/exchangeTicketActivity/listMyPage?status=${status}`, {
    pageNo,
    pageSize,
  });
}

// 通过活动id获取兑换券兑换商品列表
export function getGoodsExchangeList(activityId) {
  return fetch.get(`/marketing/api/exchangeTicketActivity/get?id=${activityId}`);
}

// 兑换券兑换商品
export function createGoodsExchangeOrder(data) {
  return fetch.post(`/marketing/api/exchangeTicketActivity/exchange`, data);
}

// 兑换券兑换商品卡支付成功后，查询订单状态
export function goodsExchangePayConfirm(ticketId) {
  return fetch.get(`/marketing/api/exchangeTicketActivity/getRecord?id=${ticketId}`);
}

// 兑换券兑换商品卡支付成功后，确认订单
export function goodsExchangeConfirmOrder(orderId) {
  return fetch.post(`/marketing/api/exchangeTicketActivity/payConfirmByClient?orderId=${orderId}`);
}

// 个人中心优惠券点击，订阅消息之后需要请求这个接口
export function pushExchangeTicketExpiredReminder() {
  return fetch.post(`/marketing/api/exchangeTicketActivity/pushExchangeTicketExpiredReminder`);
}

/**
 * 被邀请人-创建关系 API_INVITE_INVITEE_INVITEUSER
 * param: 活动id、推荐人id
 */
export function inviteUser(activityId, recommenderId) {
  const postData = {
    activityId,
    recommenderId,
  };
  return fetch.post('/marketing-service/api/inviteActivity/inviteUser', postData);
}
// 邀请有礼-获取邀请人活动信息-未登录
export function getInviteActivityInfo(id) {
  return fetch.get(`/marketing/api/inviteActivity/getInviteActivityInfo?activityId=${id}`);
}
// 邀请有礼-获取邀请人活动信息-已登录
export function getMyInviteActivityInfo(id) {
  return fetch.get(`/marketing/api/inviteActivity/getMyInviteActivityInfo?activityId=${id}`);
}
// 邀请有礼-邀请人-领取礼包
export function drawPresent(postData) {
  return fetch.post('/marketing/api/inviteActivity/drawPresent', postData);
}
/**
 * 邀请有礼(被邀请人)-未登录
 */
export function getNewuserPrize(activityId) {
  return fetch.get(
    `/marketing-service/api/inviteActivity/getNewuserPrize?activityId=${activityId}`
  );
}

/**
 * 邀请有礼(被邀请人) - 已登录
 */
export function getMyNewuserPrize(activityId, InviteUserId) {
  return fetch.get(
    `/marketing-service/api/inviteActivity/getMyNewuserPrize?activityId=${activityId}&InviteUserId=${InviteUserId}`
  );
}

/**
 * 被邀请人-满足条件后-领取礼包
 */
export function inviteeDraw(activityId) {
  return fetch.post(`/marketing-service/api/inviteActivity/draw?activityId=${activityId}`);
}
// 邀请记录
export function getInviteRecords(params) {
  return fetch.post('/marketing-service/api/inviteActivity/listMyInviteRecords', params);
}

/**
 * 获取美妆派样机对象
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E4%B8%AD%E5%BF%83-%E8%90%A5%E9%94%80%E6%B4%BB%E5%8A%A8/SY_V4.2.0/getByAppUsingGET
 */
export function beautySampleMachineGetByApp() {
  return fetch.get(`/marketing/api/beautySampleMachine/getByApp`);
}

/**
 * 检测用户位置是否在派样机范围内
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E4%B8%AD%E5%BF%83-%E8%90%A5%E9%94%80%E6%B4%BB%E5%8A%A8/SY_V4.2.0/isUserInGeoRangeUsingPOST
 */
export function beautySampleMachineIsUserInGeoRange(data) {
  return fetch.post(`/marketing/api/beautySampleMachine/isUserInGeoRange`, data);
}

/**
 * 领取兑换码
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E4%B8%AD%E5%BF%83-%E8%90%A5%E9%94%80%E6%B4%BB%E5%8A%A8/SY_V4.2.0/receiveCodeUsingPOST
 */
export function beautySampleMachineReceiveCode(data) {
  return fetch.post(`/marketing/api/beautySampleMachine/receiveCode`, data);
}
